module.exports = __webpack_public_path__ + "static/img/Architecture_审核_image@2x.62a9a2cc.png";